import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../components/default/header";
import Breadcrumb from "../../../default/breadcrumb/breadcrumb";
import BillingData from "./billingData";
import StoreSidebarMenu from "../../menu/storeSidebarMenu";

const UserBillingInfo = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>User billing info</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <StoreSidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Billing info</h3>
                    </div>
                    <BillingData />
                </div>
            </div>
        </div>

    );
}

export default UserBillingInfo;